export default {
    root: {
        fontSize: '1.2rem',
    },
};
